import * as yup from 'yup';



import { ExportTypes } from '../../../types';

export type ExportOptionsType = {
  name: string;
  path: string;
};

export const exportOptions = {
  "SLCP KPI's Compliance Line Chart": {
    name: "SLCP KPI's Compliance Line Chart",
    path: 'SlcpComplianceLineChart',
  },
  "SLCP KPI's Compliance Pie Chart": {
    name: "SLCP KPI's Compliance Pie Chart",
    path: 'SlcpCompliancePieChart'
  },
  "SLCP KPI's Not Compliant by Container Pie Chart": {
    name: "SLCP KPI's Not Compliant by Container Pie Chart",
    path: 'SlcpNonComplianceContainersPieChart',
  },
  "SLCP KPI's Not Compliant by Material Type Pie Chart": {
    name: "SLCP KPI's Not Compliant by Material Type Pie Chart",
    path: 'SlcpNonPieChart',
  },
  "SLCP EAR Compliance Review Line Chart": {
    name: 'SLCP EAR Compliance Review Line Chart',
    path: 'SlcpSubjectLineChart',
  },
  "SLCP EAR Collection Systems Pie Chart": {
    name: 'SLCP EAR Collection Systems Pie Chart',
    path: 'SlcpPieChart',
  },
  "SLCP EAR Info Cards": {
    name: 'SLCP EAR Info Cards',
    path: 'Cards',
  },
  "MORe EAR Info Cards": {
    name: 'MORe EAR Info Cards',
    path: 'MOReCards'
  },
  "MCR EAR Info Cards": {
    name: 'MCR EAR Info Cards',
    path: 'McrCards',
  }
} as const;


export const dashboardExportDefaultValue = {
  dashboard: [],
  mode: ExportTypes.WITH_FILTERS,
};

export const earLocationExportDefaultValue = {
  fileName: '',
  mode: ExportTypes.WITH_FILTERS,
};

export const validationSchema = yup.object({
  dashboard: yup.array().min(1, 'Please choose export types'),
});

export const generateFilterTitle = (
  chartTitle: string,
  legendTitle: string,
  pointAmmount?: number,
  date?: string,
) =>
  date
    ? `${pointAmmount} ${chartTitle} - ${legendTitle} - ${date}`
    : `${pointAmmount} ${chartTitle} - ${legendTitle}`;

export const activeStates = [
  { id: 1, name: 'Active', state: true },
  { id: 2, name: 'Inactive', state: false },
];
